import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'mwe-loading-spinner-extended',
  templateUrl: './loading-spinner-extended.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Add this line to ignore errors related to the dotlottie-player
})
export class LoadingSpinnerExtendedComponent {}
